module.exports = __webpack_public_path__ + "img/zhongguolvyou.f34c6a65.jpg";